export class Price {
  public net: string;
  public gross: string;
  public cycleStart: number;
  public cycleEnd: number;

  constructor(price: any = null){
    if (price) {
      this.net = price.price.net;
      this.gross = price.price.gross;
      this.cycleStart = price.cycleStart;
      this.cycleEnd = price.cycleEnd;
    }
  }
}
